// import Sidbar from "./Sidbar";
// import { Outlet } from "react-router-dom";

// function DashboardLayout() {
//   return (
//     <div className="container-fluid mb-sm-3">
//       <div className="row">
//         <div className="col-lg-2 col-md-2 col-sm-1">
//           <Sidbar />
//         </div>
//         <div className="col-lg-10 col-md-10 col-sm-12">
//           <Outlet />
//         </div>
//       </div>
//     </div>
//   );
// }
// export default DashboardLayout;
import { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidbar from "./Sidbar";

function DashboardLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  return (
    <div
      className="dashboard-layout"
      style={{
        minHeight: "100vh",
        backgroundColor: "#FDFBFC",
      }}
    >
      {/* Mobile Overlay */}
      {sidebarOpen && (
        <div
          className="sidebar-overlay d-lg-none"
          onClick={() => setSidebarOpen(false)}
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(39, 39, 39, 0.45)",
            zIndex: 1040,
          }}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`dashboard-sidebar ${
          sidebarOpen ? "sidebar-open" : "sidebar-closed"
        }`}
        style={{
          position: "fixed",
          top: 0,
          bottom: 0,
          right: 0,
          width: sidebarOpen ? "260px" : "80px",
          zIndex: 1050,
          backgroundColor: "#FFFFFF",
          borderLeft: "1px solid #EEE5E8",
          transition: "width 0.3s ease, transform 0.3s ease",
          overflow: "hidden",
        }}
      >
        <Sidbar
          collapsed={!sidebarOpen}
          onToggle={() => setSidebarOpen(!sidebarOpen)}
        />
      </aside>

      {/* Main Content */}
      <main
        className="dashboard-main"
        style={{
          marginRight: sidebarOpen ? "260px" : "80px",
          minHeight: "100vh",
          transition: "margin-right 0.3s ease",
          padding: "20px",
        }}
      >
        {/* Top Bar */}
        <div
          className="dashboard-topbar d-flex align-items-center mb-4"
          style={{
            minHeight: "55px",
          }}
        >
          <button
            type="button"
            onClick={() => setSidebarOpen(!sidebarOpen)}
            className="btn border-0 d-flex align-items-center justify-content-center"
            style={{
              width: "44px",
              height: "44px",
              borderRadius: "10px",
              backgroundColor: "#F9E9EE",
              color: "#B5183F",
              fontSize: "20px",
            }}
            aria-label="Toggle sidebar"
          >
            <i
              className={`fa-solid ${
                sidebarOpen ? "fa-bars-staggered" : "fa-bars"
              }`}
            ></i>
          </button>
        </div>

        <Outlet />
      </main>

      {/* Responsive CSS */}
      <style>
        {`
          @media (max-width: 991.98px) {
            .dashboard-sidebar {
              width: 260px !important;
              transform: translateX(100%);
            }

            .dashboard-sidebar.sidebar-open {
              transform: translateX(0);
            }

            .dashboard-sidebar.sidebar-closed {
              transform: translateX(100%);
            }

            .dashboard-main {
              margin-right: 0 !important;
              padding: 15px !important;
            }
          }

          @media (max-width: 575.98px) {
            .dashboard-main {
              padding: 10px !important;
            }

            .dashboard-topbar {
              margin-bottom: 15px !important;
            }
          }
        `}
      </style>
    </div>
  );
}

export default DashboardLayout;